import __languages from 'D:\\laragon\\www\\ghasupairdata\\storage\\app\\languages.json';
import __logo from './medias/images/topmora.svg';
import Parsley from 'parsleyjs';
import 'parsleyjs/dist/i18n/fr';
import 'parsleyjs/dist/i18n/fr.extra';

const laravel = 'D:\\laragon\\www\\ghasupairdata\\'

const config = {
    laravel : {
        public : `${laravel}public/`,
        root : laravel
    }
}

export const languages = __languages;

export const logo = __logo;

export default config;
